import { createRouter, createWebHistory } from 'vue-router'
import layoutCatalogo from '@/layoutCatalogo.vue'
import layoutAdmin from '@/layoutAdmin.vue'
import { isSessionValid } from '@/guards/sessionGuard.js'
import store from '@/store/store.js'

const routes = [
  {
    path: '/login',
    component: layoutCatalogo,
    children: [
      {
        path: '',
        component: () => import('@/layoutLogin.vue'),
        name: 'catalogoLogin',
        meta: {
          title: 'Mi Cuenta | Nexus Technology',
          metaTags: [
            { name: 'description', content: '¿Ya tienes una cuenta? Inicia sesión y aprovecha beneficios exclusivos. Explora nuestro catálogo de productos de calidad para tu infraestructura.' },
            { name: 'twitter:card', content: 'summary' },
            { name: 'twitter:title', content: 'Mi cuenta - Nexus Technology' },
            { name: 'twitter:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { name: 'twitter:description', content: '¿Ya tienes una cuenta? Inicia sesión y aprovecha beneficios exclusivos. Explora nuestro catálogo de productos de calidad para tu infraestructura.' },
            { property: 'og:title', content: 'Mi cuenta - Nexus Technology' },
            { property: 'og:description', content: '¿Ya tienes una cuenta? Inicia sesión y aprovecha beneficios exclusivos. Explora nuestro catálogo de productos de calidad para tu infraestructura.' },
            { property: 'og:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { property: 'og:url', content: 'https://store.nexus.com.pe/login' },
            { property: 'og:site_name', content: 'Nexus.Technology.SAC' },
            { property: 'og:locale', content: 'es_PE' },
            { property: 'og:type', content: 'website' },
            { rel: 'canonical', href: 'https://store.nexus.com.pe/login' }
          ]
        }
      }
    ]
  },
  {
    path: '/registrarse',
    component: layoutCatalogo,
    children: [
      { path: '', component: () => import('@/registrarse.vue'), name: 'catalogoRegister', meta: { title: 'Registrarse | Nexus Technology' } }
    ]
  },
  {
    path: '/contactanos',
    component: layoutCatalogo,
    children: [
      { path: '', component: () => import('@/views/catalogo/atencion_cliente/contactanos.vue'), name: 'catalogoContacto', meta: { title: 'Contáctanos | Nexus Technology' } }
    ]
  },
  {
    path: '/recuperarClave',
    component: layoutCatalogo,
    children: [
      { path: '', component: () => import('@/recuperarClave.vue'), name: 'catalogoRecuperarClave', meta: { title: 'Recuperar Clave | Nexus Technology' } }
    ]
  },
  {
    path: '/',
    component: layoutCatalogo,
    meta: { requiresAuth: false },
    children: [
      {
        path: '',
        component: () => import('@/views/catalogo/home.vue'),
        name: 'home',
        meta: {
          title: 'Nexus Technology',
          metaTags: [
            { name: 'description', content: 'Líderes peruanos en soluciones integrales de comunicaciones, seguridad y data center con más de 23 años de experiencia. Diseñamos y ejecutamos proyectos confiables.' },
            { name: 'twitter:card', content: 'summary' },
            { name: 'twitter:title', content: 'Nexus Technology' },
            { name: 'twitter:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { name: 'twitter:description', content: 'Líderes peruanos en soluciones integrales de comunicaciones, seguridad y data center con más de 23 años de experiencia. Diseñamos y ejecutamos proyectos confiables.' },
            { property: 'og:title', content: 'Nexus Technology' },
            { property: 'og:description', content: 'Líderes peruanos en soluciones integrales de comunicaciones, seguridad y data center con más de 23 años de experiencia. Diseñamos y ejecutamos proyectos confiables.' },
            { property: 'og:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { property: 'og:url', content: 'https://store.nexus.com.pe' },
            { property: 'og:site_name', content: 'Nexus.Technology.SAC' },
            { property: 'og:locale', content: 'es_PE' },
            { property: 'og:type', content: 'website' },
            { rel: 'canonical', href: 'https://store.nexus.com.pe' }
          ]
        }
      },
      {
        path: 'catalogo',
        component: () => import('@/views/catalogo/catalogo.vue'),
        name: 'catalogo',
        meta: {
          title: 'Catálogo | Nexus Technology',
          metaTags: [
            { name: 'description', content: '¡Amplio catálogo de soluciones para tus proyectos! Desde telecomunicaciones hasta data center. Productos de calidad y tecnología de punta.' },
            { name: 'twitter:card', content: 'summary' },
            { name: 'twitter:title', content: 'Catálogo - Nexus Technology' },
            { name: 'twitter:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { name: 'twitter:description', content: '¡Amplio catálogo de soluciones para tus proyectos! Desde telecomunicaciones hasta data center. Productos de calidad y tecnología de punta.' },
            { property: 'og:title', content: 'Catálogo - Nexus Technology' },
            { property: 'og:description', content: '¡Amplio catálogo de soluciones para tus proyectos! Desde telecomunicaciones hasta data center. Productos de calidad y tecnología de punta.' },
            { property: 'og:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { property: 'og:url', content: 'https://store.nexus.com.pe/catalogo' },
            { property: 'og:site_name', content: 'Nexus.Technology.SAC' },
            { property: 'og:locale', content: 'es_PE' },
            { property: 'og:type', content: 'website' },
            { rel: 'canonical', href: 'https://store.nexus.com.pe/catalogo' }
          ]
        }
      },
      { path: 'producto', component: () => import('@/views/catalogo/producto.vue'), name: 'producto' },
      { path: 'carrito', component: () => import('@/views/catalogo/carrito/carrito.vue'), name: 'carrito', meta: { title: 'Carrito | Nexus Technology' } },
      { path: 'estadoPago', component: () => import('@/views/catalogo/carrito/estadoPago.vue'), name: 'estadoPago', meta: { title: 'Estado de Pago | Nexus Technology' } },
      { path: 'comparar', component: () => import('@/views/catalogo/comparar.vue'), name: 'comparar', meta: { title: 'Comparar | Nexus Technology' } },
      { path: 'preguntas-frecuentes', component: () => import('@/views/catalogo/atencion_cliente/ayudaPreguntasFrecuentes.vue'), name: 'preguntas-frecuentes', meta: { title: 'Preguntas Frecuentes | Nexus Technology' } },
      {
        path: 'marcas',
        component: () => import('@/views/catalogo/marcas.vue'),
        name: 'marcas',
        meta: {
          title: 'Marcas | Nexus Technology',
          metaTags: [
            { name: 'description', content: '="¡Soluciones de vanguardia para tu empresa! Trabajamos con marcas líderes como sAf, Nexus Technology, Notifier y Opfibra en proyectos de comunicación, seguridad y data center.' },
            { name: 'twitter:card', content: 'summary' },
            { name: 'twitter:title', content: 'Marcas | Nexus Technology' },
            { name: 'twitter:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { name: 'twitter:description', content: '="¡Soluciones de vanguardia para tu empresa! Trabajamos con marcas líderes como sAf, Nexus Technology, Notifier y Opfibra en proyectos de comunicación, seguridad y data center.' },
            { property: 'og:title', content: 'Marcas | Nexus Technology' },
            { property: 'og:description', content: '="¡Soluciones de vanguardia para tu empresa! Trabajamos con marcas líderes como sAf, Nexus Technology, Notifier y Opfibra en proyectos de comunicación, seguridad y data center.' },
            { property: 'og:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { property: 'og:url', content: 'https://store.nexus.com.pe/marcas' },
            { property: 'og:site_name', content: 'Nexus.Technology.SAC' },
            { property: 'og:locale', content: 'es_PE' },
            { property: 'og:type', content: 'website' },
            { rel: 'canonical', href: 'https://store.nexus.com.pe/marcas' }
          ]
        }
      },
      {
        path: 'promociones',
        component: () => import('@/views/catalogo/catalogo.vue'),
        name: 'promocionesCatalogo',
        meta: {
          title: 'Promociones | Nexus Technology',
          metaTags: [
            { name: 'description', content: '¡No te pierdas nuestras increíbles promociones! Descubre nuestro amplio catálogo de soluciones en telecomunicaciones, seguridad y data center.' },
            { name: 'twitter:card', content: 'summary' },
            { name: 'twitter:title', content: 'Promociones - Nexus Technology' },
            { name: 'twitter:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { name: 'twitter:description', content: '¡No te pierdas nuestras increíbles promociones! Descubre nuestro amplio catálogo de soluciones en telecomunicaciones, seguridad y data center.' },
            { property: 'og:title', content: 'Promociones - Nexus Technology' },
            { property: 'og:description', content: '¡No te pierdas nuestras increíbles promociones! Descubre nuestro amplio catálogo de soluciones en telecomunicaciones, seguridad y data center.' },
            { property: 'og:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { property: 'og:url', content: 'https://store.nexus.com.pe/promociones' },
            { property: 'og:site_name', content: 'Nexus.Technology.SAC' },
            { property: 'og:locale', content: 'es_PE' },
            { property: 'og:type', content: 'website' },
            { rel: 'canonical', href: 'https://store.nexus.com.pe/promociones' }
          ]
        }
      },
      { path: 'liquidacion', component: () => import('@/views/catalogo/catalogo.vue'), name: 'liquidacionCatalogo', meta: { title: 'Liquidación | Nexus Technology' } },
      { path: 'atencion-cliente', component: () => import('@/views/catalogo/atencion_cliente/atencionCliente.vue'), name: 'atencionCliente', meta: { title: 'Atención al cliente | Nexus Technology' } },
      { path: 'politicas-internas', component: () => import('@/views/catalogo/atencion_cliente/politicasInternas.vue'), name: 'politicasInternas', meta: { title: 'Políticas internas | Nexus Technology' } },
      { path: 'politicas-internas/:tabName', component: () => import('@/views/catalogo/atencion_cliente/politicasInternas.vue'), name: 'politicasInternasTab', meta: { title: 'Políticas internas | Nexus Technology' } },
      { path: 'politica-web', component: () => import('@/views/catalogo/atencion_cliente/politicaWeb.vue'), name: 'politicaWeb', meta: { title: 'Políticas web | Nexus Technology' } },
      { path: 'beneficios', component: () => import('@/views/catalogo/atencion_cliente/beneficios.vue'), name: 'beneficios', meta: { title: 'Beneficios | Nexus Technology' } },
      { path: 'quiero-cotizacion', component: () => import('@/views/catalogo/quieroCotizacion.vue'), name: 'quieroCotizacion', meta: { title: 'Quiero una cotiazión | Nexus Technology' } },
      { path: 'orden-pedido', component: () => import('@/views/catalogo/carrito/pedido.vue'), name: 'orden-pedido', meta: { title: 'Orden de Pedido | Nexus Technology' } },
      {
        path: 'novedades',
        component: () => import('@/views/catalogo/novedades/novedades.vue'),
        name: 'novedades',
        meta: {
          title: 'Novedades | Nexus Technology',
          metaTags: [
            { name: 'description', content: '="¡Entérate de las novedades en nuestro blog! Líderes en soluciones integrales de comunicaciones, seguridad y data center en Perú. ¡Consejos y tendencias para tu empresa!' },
            { name: 'twitter:card', content: 'summary' },
            { name: 'twitter:title', content: 'Novedades | Nexus Technology' },
            { name: 'twitter:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { name: 'twitter:description', content: '="¡Entérate de las novedades en nuestro blog! Líderes en soluciones integrales de comunicaciones, seguridad y data center en Perú. ¡Consejos y tendencias para tu empresa!' },
            { property: 'og:title', content: 'Novedades | Nexus Technology' },
            { property: 'og:description', content: '="¡Entérate de las novedades en nuestro blog! Líderes en soluciones integrales de comunicaciones, seguridad y data center en Perú. ¡Consejos y tendencias para tu empresa!' },
            { property: 'og:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { property: 'og:url', content: 'https://store.nexus.com.pe/novedades' },
            { property: 'og:site_name', content: 'Nexus.Technology.SAC' },
            { property: 'og:locale', content: 'es_PE' },
            { property: 'og:type', content: 'website' },
            { rel: 'canonical', href: 'https://store.nexus.com.pe/novedades' }
          ]
        }
      },
      {
        path: 'novedades/:slug',
        component: () => import('@/views/catalogo/novedades/detalle.vue'),
        name: 'novedad',
        props: true
      },
      {
        path: 'eventos',
        component: () => import('@/views/catalogo/eventos/eventos.vue'),
        name: 'eventos',
        meta: {
          title: 'Eventos | Nexus Technology',
          metaTags: [
            { name: 'twitter:card', content: 'summary' },
            { name: 'twitter:title', content: 'Eventos | Nexus Technology' },
            { name: 'twitter:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { property: 'og:title', content: 'Eventos | Nexus Technology' },
            { property: 'og:image', content: 'https://repositorio-imagenes-b2b.s3.us-east-2.amazonaws.com/default.jpg' },
            { property: 'og:url', content: 'https://store.nexus.com.pe/eventos' },
            { property: 'og:site_name', content: 'Nexus.Technology.SAC' },
            { property: 'og:locale', content: 'es_PE' },
            { property: 'og:type', content: 'website' },
            { rel: 'canonical', href: 'https://store.nexus.com.pe/eventos' }
          ]
        }
      }
    ]
  },
  {
    path: '/admin',
    component: layoutAdmin,
    meta: { requiresAuth: true, roles: [1] },
    children: [
      { path: '', redirect: { name: 'productos' } },
      { path: '/admin/productos', component: () => import('@/views/admin/productos/productos.vue'), name: 'productos', meta: { title: 'Admin productos' } },
      { path: '/admin/usuarios', component: () => import('@/views/admin/usuarios/usuarios.vue'), name: 'usuarios', meta: { title: 'Admin usuarios' } }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: layoutCatalogo,
    children: [
      { path: '', component: () => import('@/views/NotFound.vue'), name: 'paginaNoEncontrada', meta: { title: 'Página no encontrada | Nexus Technology' } }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { left: 0, top: 0 }
  }
})
router.beforeEach(async (to, from, next) => {
  // Verificar si la ruta requiere autenticación
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const validSession = await isSessionValid()
    if (!validSession) {
      await store.dispatch('user/logout')
      next({ path: '/login' })
      return
    } else {
      const allowedRoles = to.matched.flatMap(record => record.meta.roles ? record.meta.roles : [])
      const userRole = store.state.user.data.usuario_rol
      const hasPermission = userRole.some(role => allowedRoles.includes(role))
      if (!hasPermission) {
        next({ path: '/unauthorized' })
        return
      }
    }
  }

  // Verificar rutas específicas del catálogo
  const rutasCatalogo = ['home', 'catalogo', 'producto', 'carrito']
  if (rutasCatalogo.includes(to.name)) {
    const { valid, message } = await isSessionValid()
    if (!valid && message) {
      await store.dispatch('user/logout')
      next({ path: '/login' })
      return
    }
  }

  next()
})

export default router
